<template>
  <app-layout>
   <Head title="Keywords"/>
    <template #header>
      <div class="flex justify-between">
        <h2 class="font-semibold text-xl text-gray-800 leading-tight">
          Keywords
        </h2>
        <Link href="/keywords/create" class="bg-orange-400 hover:bg-orange-500 active:bg-orange-600 focus:bg-orange-600 focus:ring-orange inline-flex items-center px-4 py-2 border border-transparent rounded-md font-bold text-xs text-white uppercase tracking-widest focus:outline-none transition ease-in-out duration-150">Create Keyword</Link
        >
      </div>
      <p>Create and share text to join keywords for contacts to subscribe to your lists.</p>
    </template>

    <div class="max-w-7xl mx-auto flex mb-6">
      <div class="w-full sm:px-6 lg:px-8">
        <div class="bg-white shadow-xl sm:rounded-lg sm:p-6 lg:p-8">
            <general-table
                :columns="columns"
                :url="route('keywords.index.json')"
                :clickableRow="{ route: 'keywords.view', id: 'id' }"
            />
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import KeywordActionItems from "../../components/KeywordActionItems";
import KeywordCreatedat from '../../components/KeywordCreatedat'
import GeneralTable from "@/components/GeneralTable/GeneralTable";
import {markRaw} from 'vue';

export default {
  components: {
    AppLayout,
  },
  props: {
  },
  data() {
    return {
      columns: [
        {
          label: "Keyword",
          name: "keyword",
          sortable: true,
        },
        {
          label: "List",
          name: "group.title",
          sortable: false
        },
        {
          label: "Created",
          name: "created_at",
          sortable: false,
          component: markRaw(KeywordCreatedat),
        },
        {
          label: "",
          name: "View",
          sortable: false,
          component: markRaw(KeywordActionItems),
          width: '70px',
        }
      ],
    };
  },
  methods: {
    
  }
};
</script>
